import { ErrorCodeEnum } from "@finway-group/shared/lib/models"
import HttpStatus from "http-status"
import qs from "qs"

export const convertUnencodedParamStringToObject = (unencodedParamString: string) =>
    qs.parse(unencodedParamString, {
        decoder: (str) => str,
    })

export const serializeParams = (params: Record<string, any>) => qs.stringify(params, { encode: true, arrayFormat: "comma" })

export const isWeavrAuthError = (error: { response?: { status?: number; data?: { errorCode?: string } } }, originalRequest: { _weavrRetry?: boolean }) => {
    const errorCode = error.response?.data?.errorCode
    return (
        error.response?.status === HttpStatus.UNPROCESSABLE_ENTITY &&
        (errorCode === ErrorCodeEnum.WEAVR_AUTH_REQUIRED || errorCode === ErrorCodeEnum.WEAVR_STEP_UP_AUTH_REQUIRED) &&
        !originalRequest._weavrRetry
    )
}
